import type { CSSProperties } from "react";

/**
 * The margin box for `<fp-page-number>` and `<fp-page-count>`. An inline box
 * drops vertical margin, so an authored margin promotes the counter to an
 * atomic inline-block; an unset one leaves it inline, exactly as it rendered
 * before margins were authorable.
 * @param margin - The authored `margin` shorthand, or null when unset
 * @returns The style fragment, empty when no margin is authored
 */
export function counterMarginStyle(
  margin: string | null | undefined,
): CSSProperties {
  const trimmed = margin?.trim() ?? "";
  if (trimmed === "") {
    return {};
  }
  return { display: "inline-block", margin: trimmed };
}
